// extracted by mini-css-extract-plugin
export default {"group":"CheckoutCharacteristic_group__LFbfu","characteristic":"CheckoutCharacteristic_characteristic__SFm_W","title":"CheckoutCharacteristic_title__WKlHK"};